(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-retail-admin/row-result/assets/javascripts/tipsen-result.js') >= 0) return;  svs.modules.push('/components/marketplace-retail-admin/row-result/assets/javascripts/tipsen-result.js');
"use strict";


const ReactButtonBet = svs.ui.ReactButtonBet;


const defaultProps = {
  events: null,
  hasMSign: false,
  isReduceFree: false,
  mSigns: [],
  percentages: [],
  uSigns: []
};

const TipsenResult = _ref => {
  let events = _ref.events,
    isReduceFree = _ref.isReduceFree,
    hasMSign = _ref.hasMSign,
    percentages = _ref.percentages,
    uSigns = _ref.uSigns,
    mSigns = _ref.mSigns;
  const _renderRow = (eventItem, eventIndex) => {
    const _ref2 = eventItem || {},
      eventNumber = _ref2.eventNumber,
      eventDescription = _ref2.eventDescription,
      participantType = _ref2.participantType;
    const _ref3 = percentages[eventIndex] || {},
      percentage1 = _ref3.percentage1,
      percentageX = _ref3.percentageX,
      percentage2 = _ref3.percentage2;
    const eventComment = participantType === 'Player' ? 'Vem gör flest mål?' : null;
    return React.createElement("div", {
      className: "retail-tipsen-result-row",
      key: eventNumber || eventIndex
    }, React.createElement("div", {
      className: "event"
    }, React.createElement("div", null, "".concat(eventNumber, ". ").concat(eventDescription)), Boolean(eventComment) && React.createElement("div", {
      className: "event-comment"
    }, eventComment)), Boolean(isReduceFree) && React.createElement(React.Fragment, null, React.createElement("div", {
      className: "bet"
    }, React.createElement(ReactButtonBet, {
      label: "".concat(percentage1, "%"),
      selected: percentage1 > 0,
      size: "200"
    })), React.createElement("div", {
      className: "bet"
    }, React.createElement(ReactButtonBet, {
      label: "".concat(percentageX, "%"),
      selected: percentageX > 0,
      size: "200"
    })), React.createElement("div", {
      className: "bet"
    }, React.createElement(ReactButtonBet, {
      label: "".concat(percentage2, "%"),
      selected: percentage2 > 0,
      size: "200"
    }))), !isReduceFree && React.createElement(React.Fragment, null, Boolean(hasMSign) && React.createElement("div", {
      className: "bet"
    }, React.createElement(ReactButtonBet, {
      label: "M",
      selected: mSigns[eventIndex],
      size: "200"
    })), React.createElement("div", {
      className: "bet"
    }, React.createElement(ReactButtonBet, {
      label: "1",
      selected: percentage1 > 0,
      size: "200",
      system: uSigns[eventIndex] === '1' ? 'U' : null
    })), React.createElement("div", {
      className: "bet"
    }, React.createElement(ReactButtonBet, {
      label: "X",
      selected: percentageX > 0,
      size: "200",
      system: uSigns[eventIndex] === 'X' ? 'U' : null
    })), React.createElement("div", {
      className: "bet"
    }, React.createElement(ReactButtonBet, {
      label: "2",
      selected: percentage2 > 0,
      size: "200",
      system: uSigns[eventIndex] === '2' ? 'U' : null
    }))));
  };
  return React.createElement("div", {
    className: "retail-tipsen-result",
    "data-testid": "tipsen-result"
  }, React.createElement("div", {
    className: "retail-tipsen-result-header"
  }, React.createElement("div", {
    className: "event"
  }, "Matcher"), Boolean(!isReduceFree && hasMSign) && React.createElement("div", {
    className: "bet"
  }), React.createElement("div", {
    className: "bet"
  }, "1"), React.createElement("div", {
    className: "bet"
  }, "X"), React.createElement("div", {
    className: "bet"
  }, "2")), (events || []).map(_renderRow));
};
TipsenResult.defaultProps = defaultProps;
setGlobal('svs.components.marketplaceRetailAdmin.rowResult.TipsenResult', TipsenResult);

 })(window);